import { useForm } from "react-hook-form"

export function useAgendaVisitaDiaria() {
  const form = useForm<any>({})
  const {
    formState:{errors},
    control,
  }=useForm()
  return {
   form, control, errors
  }
}